import { Outlet } from 'react-router-dom';
import { AuthGuard } from '@features/auth';

/**
 * Root layout wrapping the entire app with AuthGuard.
 * Unauthenticated users are redirected to the Cognito hosted UI.
 * Expired sessions show a re-authentication prompt.
 *
 * Requirements: 1.1, 1.3, 1.7
 */
export function RootLayout() {
  return (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  );
}
